// Unread message indicator types
export const INDICATOR_RED_DOT = 0;
export const INDICATOR_BOLD_TEXT = 1;
